import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import { Row } from "components/Containers";
import Tooltip from "components/Tooltip";
import Icon, { ICON_SIZE, ICON_TYPE } from "components/Icon";
import { formatDate } from "utils";
import { colors } from "style";

/**
 * ApplicantInvitedAt
 *
 * @param {Object} data
 */
const ApplicantInvitedAt = ({ data }) =>
  data?.invitedAt ? (
    <Row gap="0.4rem" noWrap>
      <div css={styles.icon_container}>
        <Tooltip tooltipId="Missions.Applicants.ApplicantInvitedAt" key={data?.invitedAt} hideIcon>
          <Icon type={ICON_TYPE.checkmark} size={ICON_SIZE.small} color="inherit" />
        </Tooltip>
      </div>
      {formatDate(data?.invitedAt, "MMM DD, YYYY", true, true)}
    </Row>
  ) : null;

const styles = {
  icon_container: css`
    border-radius: 1rem;
    background: ${colors.grayAnatomyLight4};
    width: 3.5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

ApplicantInvitedAt.propTypes = {
  data: PropTypes.shape({
    invitedAt: PropTypes.string,
  }).isRequired,
};

export default ApplicantInvitedAt;
